import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    activeBookings: [],
    pastBookings: [],
};
export const bookingsSlice = createSlice({
    name: 'bookings',
    initialState,
    reducers: (create) => ({
        setActiveBookings: create.reducer((state, action) => {
            state.activeBookings = action.payload;
        }),
        setPastBookings: create.reducer((state, action) => {
            state.pastBookings = action.payload;
        }),
    }),
    selectors: {
        getActiveBookings: (state) => state.activeBookings,
        getPastBookings: (state) => state.pastBookings,
    },
});
export const { setActiveBookings, setPastBookings } = bookingsSlice.actions;
export const { getActiveBookings, getPastBookings } = bookingsSlice.getSelectors((state) => state.bookings);
export default bookingsSlice.reducer;
